// eslint-disable-next-line prettier/prettier
const { VITE_APP_PLATFORM_SERVICE, VITE_APP_PLATFORM_SERVICE_KEY } = import.meta.env

const platformServiceAPI = {
    platformServiceETIdata: async (shipments) => {
        const response = await fetch(
            `${VITE_APP_PLATFORM_SERVICE}/api/v1/equipment/eta`,
            {
                method: "POST",
                module: "RVP",
                headers: {
                    "Content-Type": "application/json",
                    apiKey: VITE_APP_PLATFORM_SERVICE_KEY,
                },
                body: JSON.stringify({
                    paging: {
                        recordsPerPage: 100,
                        pageRequested: 1,
                    },
                    module: "RVP",
                    shipments: [...shipments],
                }),
            }
        )
        try {
            if (response.status === 401) {
                throw new Error("Invalid authentication credentials")
            } else if (response.ok && response.status === 200) {
                let out = await response.json()
                return out
            } else {
                throw new Error("Platfrom api for ETI failed")
            }
        } catch (e) {
            return Promise.reject(e)
        }
    },
}

export default platformServiceAPI
